import React, {useState, useEffect} from 'react'
import styles from './styles.module.scss'
import branchApi from "../../../../store/branchStore/branchApi";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useCurrentBranch} from "../../../../hooks/useCurrentBranch";
import {useHistory} from "react-router-dom";
import { Trans } from "react-i18next";
import Checkbox from "../../../../components/FormElements/Checkbox";
import branchActions from "../../../../store/branchStore/branchActions";

const AutoNotifications = () => {
  const { info, pending } = useSelector(s => s.branchReducer);
  const history = useHistory()
  const dispatch = useDispatch()
  const { currentRole, currentBranch, groupId } = useCurrentBranch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    bonus_expiry_messages: false,
    cross_bonus_messages: false,
    bonus_after_payment_messages: false,
    add_bonus_messages: false,
    bonus_activation_messages: false,
    level_up_messages: true,
  })

  useEffect(() => {
    if (info?.configuration) {
      setState({
        level_up_messages: info?.configuration?.notification_toggles?.level_up_messages !== false,
        bonus_expiry_messages: info?.configuration?.notification_toggles?.bonus_expiry_messages,
        cross_bonus_messages: info?.configuration?.notification_toggles?.cross_bonus_messages,
        bonus_after_payment_messages: info?.configuration?.notification_toggles?.bonus_after_payment_messages,
        add_bonus_messages: info?.configuration?.notification_toggles?.add_bonus_messages,
        bonus_activation_messages: info?.configuration?.notification_toggles?.bonus_activation_messages,
      })
    }
  }, [info?.configuration])

  const handleChange = (field, value) => {
    setLoading(true)
    branchApi.postBranchesConfigurationNotifcationToggles(info?.id, {
      ...state,
      [field]: value,
    })
      .then(res => {
        dispatch(branchActions.getBranch(info?.id))
      })
      .finally(() => setLoading(false))
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <div className={styles.container}>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Trans i18nKey="AutoNotifications.mail1">
            <p>
              Message about accrual of bonuses from a <b>transaction</b> (Make a payment)
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.bonus_after_payment_messages} onChange={(e) => handleChange('bonus_after_payment_messages', true)} />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.bonus_after_payment_messages} onChange={(e) => handleChange('bonus_after_payment_messages', false)} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
               <Trans i18nKey="AutoNotifications.mail2">
            <p>
              Message about <b>gift</b> bonuses (Accrue a bonus)
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.add_bonus_messages} onChange={(e) => handleChange('add_bonus_messages', true)} />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.add_bonus_messages} onChange={(e) => handleChange('add_bonus_messages', false)} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Trans i18nKey="AutoNotifications.mail3">
            <p>
              Message about <b>activation</b> of bonuses
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.bonus_activation_messages} onChange={(e) => handleChange('bonus_activation_messages', true)}  />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.bonus_activation_messages} onChange={(e) => handleChange('bonus_activation_messages', false)} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Trans i18nKey="AutoNotifications.mail4">
            <p>
              Message about <b>burning</b> of bonuses
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.bonus_expiry_messages} onChange={(e) => handleChange('bonus_expiry_messages', true)} />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.bonus_expiry_messages} onChange={(e) => handleChange('bonus_expiry_messages', false)} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Trans i18nKey="AutoNotifications.mail5">
            <p>
              Message about <b>cross</b> promotion
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.cross_bonus_messages} onChange={(e) => handleChange('cross_bonus_messages', true)} />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.cross_bonus_messages} onChange={(e) => handleChange('cross_bonus_messages', false)} />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Trans i18nKey="AutoNotifications.mail6">
            <p>
              Message about reaching a <b>new level</b> of the loyalty program
            </p>
          </Trans>
          <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
            <Checkbox disabled={loading || pending} label={t('switch_on')} checked={state.level_up_messages} onChange={(e) => handleChange('level_up_messages', true)} />
            <Checkbox disabled={loading || pending} label={t('switch_off')} checked={!state.level_up_messages} onChange={(e) => handleChange('level_up_messages', false)} />
          </div>
        </div>






      </div>
    </div>
  )
}

export default AutoNotifications